export const toDollars = (amount: number, decimalPlaces: number): string => {
  return Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits: decimalPlaces,
  }).format(amount);
};

export const toFormattedNumber = (
  amount: number,
  decimalPlaces: number
): string => {
  return Intl.NumberFormat("en-AU", {
    maximumFractionDigits: decimalPlaces,
  }).format(amount);
};

export const toThousands = (
  amount: number,
  currency: boolean = false
): string => {
  if (amount > -1000 && amount < 1000) {
    return currency ? toDollars(amount, 0) : toFormattedNumber(amount, 0);
  } else {
    const thousands = Math.abs(amount) / 1000;
    const sign = amount < 0 ? "-" : "";
    const decimalPart = thousands % 1;
    const formattedThousands =
      decimalPart === 0 ? thousands.toFixed(0) : thousands.toFixed(1);
    return `${sign}${currency ? "$" : ""}${formattedThousands}k`;
  }
};
